import Header from "../components/Header";
import { useTranslation } from "react-i18next";

const GioiThieuSanPham = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();
  return (
    <div className="wrapper">
      <div className="container-web gioithieusanpham bgnew">
        <Header title={t("Giới thiệu sản phẩm")} />

        <main className="p-3" style={{ fontSize: 12 }}>
          <p>
            {t(
              "Tiền thân của Vingroup là Tập đoàn Technocom, thành lập năm 1993 tại Ucraina. Đầu những năm 2000, Technocom trở về Việt Nam, tập trung đầu tư vào lĩnh vực du lịch và bất động sản với hai thương hiệu chiến lược ban đầu là Vinpearl và Vincom."
            )}
          </p>

          <p>
            {t(
              "Đến tháng 1/2012, công ty CP Vincom và Công ty CP Vinpearl sáp nhập, chính thức hoạt động dưới mô hình Tập đoàn với tên gọi Tập đoàn Vingroup – Công ty CP."
            )}
          </p>
          <p>
            {t(
              "Vingroup là một trong những Tập đoàn kinh tế tư nhân đa ngành lớn nhất châu Á với giá trị vốn hóa thị trường đạt gần 16 tỷ đô la Mỹ."
            )}
          </p>
          <p></p>
          <p>
            {t(
              "Khởi đầu tại Việt Nam với lĩnh vực du lịch và bất động sản, Vingroup đã phát triển mạnh mẽ trở thành tập đoàn kinh doanh đa ngành với hệ sinh thái toàn diện từ bất động sản nhà ở, thương mại, du lịch đến các dịch vụ tiêu dùng gồm bán lẻ, y tế, giáo dục, nông nghiệp."
            )}
          </p>
          <p>
            {t(
              "Trên tinh thần phát triển bền vững và chuyên nghiệp, Vingroup hiện đang hoạt động trong ba lĩnh vực kinh doanh cốt lõi, bao gồm:"
            )}
            <br />
            {t("- Công nghệ - Công nghiệp")}
            <br />
            {t("- Thương mại Dịch vụ")}
            <br />
            {t("- Thiện nguyện Xã hội")}
            <br />
            {t(
              "Với mong muốn đem đến cho thị trường những sản phẩm – dịch vụ theo tiêu chuẩn quốc tế và những trải nghiệm hoàn toàn mới về phong cách sống hiện đại, ở bất cứ lĩnh vực nào Vingroup cũng chứng tỏ vai trò tiên phong, dẫn dắt sự thay đổi xu hướng tiêu dùng."
            )}
          </p>
        </main>
      </div>
    </div>
  );
};

export default GioiThieuSanPham;
